import { render, staticRenderFns } from "./clothDialog.vue?vue&type=template&id=15e87695&scoped=true"
import script from "./clothDialog.vue?vue&type=script&lang=js"
export * from "./clothDialog.vue?vue&type=script&lang=js"
import style0 from "./clothDialog.vue?vue&type=style&index=0&id=15e87695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e87695",
  null
  
)

export default component.exports